import {
  WorkOrderTabProps,
} from '@features/dashboard/components/WorkOrders/WorkOrderProps';
import HelperProfileIcon from '@shared/assets/icons/HeaderProfileIcon';
import HelperSettingsIcon from '@shared/assets/icons/HeaderSettingsIcon';
import {Dimensions} from 'react-native';

/**
 * Toggle for using mock data instead of real API calls.
 * Useful for offline testing or development without a backend.
 */
export const appConstants = {
  isMock: false,
};

/**
 * Loader sizes for ActivityIndicator or any spinner components.
 */
export const loaderSize = {
  small: 'small',
  large: 'large',
} as const;

/**
 * Button variants for styling different types of buttons.
 * These control colors, borders, and other visual styles.
 */
export const buttonVariants = {
  primary: 'primary',
  secondary: 'secondary',
} as const;

/**
 * Button sizes to adjust padding, height, and font size.
 */
export const buttonSizes = {
  small: 'small',
  medium: 'medium',
  mLarge: 'mLarge',
  large: 'large',
  xlarge: 'xlarge',
  xs: 'xs',
} as const;

export const profileOptions: WorkOrderTabProps[] = [
  { text: 'header.viewProfile', value: 'profile', icon: HelperProfileIcon },
  { text: 'header.settings', value: 'settings', icon: HelperSettingsIcon },
];

/**
 * Calendar picker popup height — scales with the device/viewport height to
 * accommodate months that span 5 rows (plus an optional time picker) without
 * showing an internal scrollbar, while staying visually compact on larger screens.
 *
 * Formula: 48% of viewport height, capped between 380 px and 430 px.
 *   • 900 px viewport → min(430, max(380, 432)) = 430 px  (enough for 5-row month + time)
 *   • 800 px viewport → min(430, max(380, 384)) = 384 px
 *   • 700 px viewport → min(430, max(380, 336)) = 380 px  (safe floor)
 */
export const CALENDAR_HEIGHT = Math.min(
  430,
  Math.max(380, Math.round(Dimensions.get('window').height * 0.43)),
);

export const accessibiltyText = {
  dropdown: {
    accessibilityLabelKey: 'common.accessibility.dropdown',
    accessibilityHintKey: 'common.accessibility.dropdownHint',
    itemSelectedKey: 'common.accessibility.dropdownItemSelected',
    itemNotSelectedKey: 'common.accessibility.dropdownItemNotSelected',
    itemSelectedAnnouncementKey:
      'common.accessibility.dropdownItemSelectedAnnouncement',
  },
};

export const pinAuthErrors = {
  invalid: 'Invalid PIN. Please try again.',
  valid: 'Success',
};

export const mockedCreatedUserID = 1165
export const disableFunctionality = true;